// src/pages/AnalyticsPage.js
import React from 'react';
import { useParams } from 'react-router-dom';
import AnalyticsManager from '../components/ui/AnalyticsManager';

function AnalyticsPage() {
	const { surveyId } = useParams();

	return (
		<AnalyticsManager surveyId={surveyId} />
	);
}

export default AnalyticsPage;